import {
    useMutation,
    useQueryClient
} from "react-query";
import {defaultError, defaultSuccess} from "../../../libs/utils";
import {rejectCertificate} from "../../../services/api/certificates";
import {CERTIFICATES_ALL_QUERY_KEY} from "./useCertificates";
import {COMPANY_USER_CERTIFICATES_ALL_QUERY_KEY} from "../company-user-certificates/useCompanyUserCertificates";
import {format} from "date-fns";

export type UseRejectCertificateParams = {
    id: number;
    internalComment: null | string;
    publicComment: null | string;
    expiresAt: null | Date;
};

export const useRejectCertificate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({
            id,
            ...values
        }: UseRejectCertificateParams) => {
            return rejectCertificate(id, {
                ...values,
                expiresAt: values.expiresAt ? format(values.expiresAt, 'yyyy-MM-dd') : null
            });
        },
        onError: (error: any, variables, context) => {
            defaultError(`Failed to reject certificate: ${error?.message}`);
        },

        onSuccess: (data, variables, context) => {
            defaultSuccess("Certificate rejected.");
            queryClient.invalidateQueries(CERTIFICATES_ALL_QUERY_KEY);
            queryClient.invalidateQueries(COMPANY_USER_CERTIFICATES_ALL_QUERY_KEY);
        }
    });
};
